import { render, staticRenderFns } from "./venda.vue?vue&type=template&id=35f70714&"
import script from "./venda.vue?vue&type=script&lang=js&"
export * from "./venda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports